import { ChevronDown, ChevronUp, Download, FileSpreadsheet } from 'lucide-react'
import React from 'react'

import { Button, DropdownMenu } from 'slab'

interface DownloadTemplateDropdownProps {
  onDownloadTemplate: (templateType: 'empty' | 'populated') => boolean | void
}

const DownloadTemplateDropdown: React.FC<DownloadTemplateDropdownProps> = ({
  onDownloadTemplate,
}) => {
  return (
    <DropdownMenu
      trigger={({ open }) => (
        <Button
          variant='secondary'
          rightIcon={open ? ChevronUp : ChevronDown}
          leftIcon={Download}
        >
          Download Template
        </Button>
      )}
      align='start'
    >
      <DropdownMenu.Item
        leftIcon={FileSpreadsheet}
        onSelect={() => onDownloadTemplate('empty')}
      >
        Blank Template
      </DropdownMenu.Item>
      <DropdownMenu.Item
        leftIcon={FileSpreadsheet}
        onSelect={() => onDownloadTemplate('populated')}
      >
        All Unmapped Plans
      </DropdownMenu.Item>
    </DropdownMenu>
  )
}

export default DownloadTemplateDropdown
